import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { DonorSchedulingActions } from '@/app/slices/donorScheduling';
import { LOAD_DONOR_PARTNERS_OPTION_VALUES } from '@/enums';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

export function useClearBillAccountOnPartnership() {
  const dispatch = useDispatch();
  const isClearBillAccountOnPartnershipEnabled = useFeatureFlag(
    'Clear_Bill_Account_On_Partnership',
  );

  const shouldClearBillAccount = useCallback(
    (loadDonorPartners?: number | null, pool?: boolean | null) =>
      isClearBillAccountOnPartnershipEnabled &&
      loadDonorPartners === LOAD_DONOR_PARTNERS_OPTION_VALUES.YES &&
      pool !== true,
    [isClearBillAccountOnPartnershipEnabled],
  );

  const clearBillAccountIfBillingPartnership = useCallback(
    (loadDonorPartners?: number | null, pool?: boolean | null) => {
      if (!shouldClearBillAccount(loadDonorPartners, pool)) return false;
      dispatch({
        type: DonorSchedulingActions.UPDATE_BILLING_ACCOUNT,
        payload: null,
      });
      return true;
    },
    [dispatch, shouldClearBillAccount],
  );

  return {
    isClearBillAccountOnPartnershipEnabled,
    shouldClearBillAccount,
    clearBillAccountIfBillingPartnership,
  };
}
